<template>
  <div>
    <div style="margin-bottom: 10px; display: flex; align-items: center;">
      <el-select 
        v-model="pageSize" 
        placeholder="单页显示条数" 
        style="width: 120px;"
      >
        <el-option label="5条/页" :value="5"></el-option>
        <el-option label="10条/页" :value="10"></el-option>
        <el-option label="15条/页" :value="15"></el-option>
        <el-option label="20条/页" :value="20"></el-option>
      </el-select>
    </div>
    <!-- 打印按钮 -->
    <el-button 
      type="primary" 
      icon="el-icon-printer" 
      @click="handlePrint" 
      style="margin-bottom: 20px;"
    >
      打印全部表单 (共 {{ totalPages }} 页)
    </el-button>

    <!-- 打印内容容器 -->
    <div id="print-container">
      <!-- 模板渲染容器 -->
      <div 
        class="print-template" 
        :style="templateContainerStyle"
        v-if="form.tempItems && form.tempItems.length"
      >
        <!-- 遍历 tempItems 渲染每个元素 -->
        <div 
          v-for="(item, index) in form.tempItems" 
          :key="item.uuid || index"
          :class="['template-item', 'item-' + item.type]"
          :style="getItemStyle(item)"
        >
          <!-- 文本类型元素 -->
          <template v-if="item.type === 'braid-txt'">
            <div v-html="getTextContent(item)" class="text-content"></div>
          </template>

          <!-- 表格类型元素 -->
          <template v-if="item.type === 'braid-table'">
            <div class="table-wrapper">
              <table class="detail-table">
                <thead>
                  <tr>
                    <th v-for="col in columns" :key="col.name">{{ col.title }}</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- 数据行 -->
                  <tr v-for="(row, rowIndex) in product" :key="rowIndex">
                    <td v-for="col in columns" :key="col.name">
                      {{ row[col.name] || '' }}
                    </td>
                  </tr>
                  <!-- 合计行 -->
                  <tr v-if="showSummary" class="total-row">
                    <td :colspan="summaryColspan" style="text-align: center;">
                      {{ summaryText }}
                    </td>
                    <!-- 数量列 -->
                    <td v-if="hasQuantityColumn">{{ quantitySummaryText }}</td>
                    <!-- 数量列和金额列之间的填充 -->
                    <td v-for="n in betweenColumns" :key="'between-' + n"></td>
                    <!-- 金额列 -->
                    <td v-if="hasAmountColumn">{{ amountSummaryText }}</td>
                    <!-- 金额列之后的填充 -->
                    <td v-for="n in afterAmountColumns" :key="'after-amt-' + n"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </div>

      <!-- 加载提示 -->
      <div v-else class="loading-container">
        <i class="el-icon-loading"></i>
        <span>加载模板中...</span>
      </div>
    </div>
  </div>
</template>

<script>
import Print_tempApi from '@/api/print_temp.js';
import DdeliveryApi from '@/api/ddelivery.js';

export default {
  name: 'PrintForm',
  data() {
    return {
      form: {
        all_num: '',
        all_price: '',
        amout_num:'',
        amout_money:'',
        tempItems: [],
        width: 750,
        height: 550
      },
      address: '',
      company_address: '',
      customer_name: '',
      complaint_phone: '',
      phone: '',
      order_code: '',
      order_date: '',
      product: [],
      print_temp_id: 0,
      curPage: 10,
      formInline: {
        store_id: 0,
        id: 0
      },
      tableData: [],
      tableTitle:[],
      pageSize: 5, // 单页最大商品数
      paginatedData: [], // 拆分后的多页数据
      quantityColumnIndex: -1, // 数量列索引
      amountColumnIndex: -1,   // 金额列索引
    };
  },
  computed: {
    // 模板容器样式
    templateContainerStyle() {
      return {
        width: this.form.width + 'px',
        height: this.form.height + 'px',
        margin: '0 auto',
        position: 'relative',
        border: '1px dashed #ccc',
        padding: '20px'
      };
    },
    // 拆分商品数据为多页
    splitProductData() {
      const result = [];
      const total = this.product.length;
      if (total === 0) return result;
      
      // 按pageSize拆分数组
      for (let i = 0; i < total; i += this.pageSize) {
        result.push(this.product.slice(i, i + this.pageSize));
      }
      return result;
    },
    // 计算总页数
    totalPages() {
      return this.splitProductData.length;
    },
    // 检测表头是否有金额列
    hasAmountColumn() {
      return this.amountColumnIndex !== -1;
    },
    // 检测表头是否有数量列
    hasQuantityColumn() {
      return this.quantityColumnIndex !== -1;
    },
    // 获取数量列名
    quantityColumnName() {
      if (this.quantityColumnIndex !== -1 && this.columns) {
        return this.columns[this.quantityColumnIndex].name;
      }
      return null;
    },
    // 获取金额列名
    amountColumnName() {
      if (this.amountColumnIndex !== -1 && this.columns) {
        return this.columns[this.amountColumnIndex].name;
      }
      return null;
    },
    // 自动计算合计值
    calculatedTotals() {
      const totals = {
        quantityTotal: 0,
        amountTotal: 0
      };
      
      if (this.product && this.product.length > 0) {
        // 计算数量合计
        if (this.quantityColumnName) {
          totals.quantityTotal = this.product.reduce((sum, item) => {
            return sum + (parseFloat(item[this.quantityColumnName]) || 0);
          }, 0);
        }
        
        // 计算金额合计
        if (this.amountColumnName) {
          totals.amountTotal = this.product.reduce((sum, item) => {
            return sum + (parseFloat(item[this.amountColumnName]) || 0);
          }, 0);
        }
      }
      
      return {
        quantityTotal: totals.quantityTotal.toFixed(0),
        amountTotal: totals.amountTotal.toFixed(2)
      };
    },
    // 是否显示合计
    showSummary() {
      return (this.hasAmountColumn || this.hasQuantityColumn) && 
             this.product && this.product.length > 0;
    },
    // 合计文本 - 有金额就显示金额，没有就显示数量
    summaryText() {
      if (this.hasAmountColumn) {
        return '合计金额：'+this.form.amout_money;
      } else if (this.hasQuantityColumn) {
        return '合计数量：'+this.form.amout_num;
      }
      return '';
    },
    // 数量合计文本
    quantitySummaryText() {
      return this.hasQuantityColumn ? this.calculatedTotals.quantityTotal: '';
    },
    // 金额合计文本
    amountSummaryText() {
      return this.hasAmountColumn ? this.calculatedTotals.amountTotal : '';
    },
    // 数量列和金额列之间的填充列数
    betweenColumns() {
      if (!this.hasQuantityColumn || !this.hasAmountColumn) return 0;
      return Math.max(0, this.amountColumnIndex - this.quantityColumnIndex - 1);
    },
    // 金额列之后的填充列数
    afterAmountColumns() {
      if (!this.columns) return 0;
      if (!this.hasAmountColumn) {
        // 如果没有金额列，但有数量列，则计算数量列之后的列数
        if (this.hasQuantityColumn) {
          return Math.max(0, this.columns.length - this.quantityColumnIndex - 1);
        }
        return 0;
      }
      return Math.max(0, this.columns.length - this.amountColumnIndex - 1);
    },
    // 合计行colspan - 第一个单元格的跨列数
    summaryColspan() {
      if (!this.columns) return 1;
      
      // 如果有数量列，第一个单元格跨列到数量列之前
      if (this.hasQuantityColumn) {
        return this.quantityColumnIndex;
      }
      // 如果没有数量列但有金额列，第一个单元格跨列到金额列之前
      else if (this.hasAmountColumn) {
        return this.amountColumnIndex;
      }
      // 如果都没有，跨所有列
      else {
        return this.columns.length;
      }
    }
  },
  watch: {
    // 监听商品数据变化，自动拆分
    product: {
      deep: true,
      handler() {
        this.paginatedData = this.splitProductData;
      }
    },
    // 监听分页大小变化，重新拆分
    pageSize() {
      this.paginatedData = this.splitProductData;
    },
    // 监听columns变化，检测列位置
    columns: {
      deep: true,
      handler(newColumns) {
        this.detectColumnPositions(newColumns);
      }
    }
  },
  created() {
    this.formInline.id = this.$route.query.id || 0;
    this.print_temp_id = this.$route.query.print_temp_id || 0; 
    this.getData();
    this.getTableList();
  },
  methods: {
    // 检测列位置
    detectColumnPositions(columns) {
      if (!columns || !Array.isArray(columns)) return;
      
      // 重置索引
      this.quantityColumnIndex = -1;
      this.amountColumnIndex = -1;
      
      // 遍历columns检测列位置
      columns.forEach((col, index) => {
        const title = col.title || '';
        
        // 检测数量列
        if (title.includes('数量')) {
          this.quantityColumnIndex = index;
        }
        
        // 检测金额列
        if (title.includes('金额')) {
          this.amountColumnIndex = index;
        }
      });
      
      // console.log('列位置检测结果:', {
      //   quantityColumnIndex: this.quantityColumnIndex,
      //   amountColumnIndex: this.amountColumnIndex,
      //   betweenColumns: this.betweenColumns,
      //   afterAmountColumns: this.afterAmountColumns,
      //   columns: columns.map((col, index) => `${index + 1}. ${col.title} (${col.name})`)
      // });
    },
    
    // 获取模板数据
    getData() {
      const self = this;
      Print_tempApi.detail({ print_temp_id: self.print_temp_id }, true)
        .then(function(res) {
          self.form = res.data;
          self.tableTitle = res.data.tempItems.filter(item => item.type === 'braid-table');
          if (self.tableTitle.length > 0) {
            self.columns = self.tableTitle[0].columns;
            // 检测列位置
            self.detectColumnPositions(self.columns);
          }
        })
        .catch(function(error) {
          console.error('获取模板失败', error);
        });
    },
    
    // 解析文本内容
    getTextContent(item) {
      const self = this;
      let content = item.value || item.defaultValue;
      
      // 动态内容替换
      const replacements = {
        '单据日期': self.order_date,
        '单据编号': self.order_code,
        '客户名称': self.customer_name,
        '客户地址': self.address,
        '联系电话': self.phone,
        '公司地址': self.company_address
      };
      
      // 执行替换
      for (const [key, value] of Object.entries(replacements)) {
        const regex = new RegExp(`${key}:`, 'g');
        content = content.replace(regex, `${key}: ${value}`);
      }
      
      return content;
    },
    
    // 获取业务数据
    getTableList() {
      const self = this;
      const params = Object.assign({}, self.formInline, { page: self.curPage });
      
      DdeliveryApi.listp(params, true)
        .then(function(data) {
          self.tableData = data.data;
          
          if (self.tableData.length > 0) {
            const mainData = self.tableData[0];
            self.product = mainData.data || [];
            self.form.all_num = mainData.all_num;
            self.form.all_price = mainData.all_price;
            self.form.amout_money = mainData.amout_money;
            self.form.amout_num = mainData.amout_num;
            
            // 更新动态数据
            self.address = mainData.address;
            self.company_address = mainData.company_address;
            self.customer_name = mainData.customer_name;
            self.complaint_phone = mainData.complaint_phone;
            self.order_code = mainData.order_code;
            self.order_date = mainData.order_date;
            self.phone = mainData.phone;
          }
        })
        .catch(function(error) {
          console.error('获取业务数据失败', error);
        });
    },
    
    // 获取元素样式
    getItemStyle(item) {
      const itemStyle = item.style || {};
      return {
        position: 'absolute',
        left: item.left + 'px',
        top: item.top + 'px',
        width: item.width + 'px',
        height: item.height + 'px',
        fontSize: (itemStyle.FontSize || 12) + 'px',
        color: itemStyle.FontColor || '#000',
        fontWeight: itemStyle.Bold ? 'bold' : 'normal',
        fontStyle: itemStyle.Italic ? 'italic' : 'normal',
        textDecoration: itemStyle.Underline ? 'underline' : 'none',
        textAlign: itemStyle.Alignment || 'left',
        zIndex: itemStyle.zIndex || 0,
        overflow: 'hidden',
        boxSizing: 'border-box'
      };
    },
    
    
    // 打印功能
    handlePrint() {
      if (this.product.length === 0) {
        this.$message.warning('没有可打印的数据');
        return;
      }

      const printContainer = document.getElementById('print-container');
      if (!printContainer) {
        this.$message.error('未找到打印内容');
        return;
      }

      // 获取原始模板内容（含文本、表格布局）
      const originalTemplate = printContainer.querySelector('.print-template');
      if (!originalTemplate) {
        this.$message.error('未找到模板内容');
        return;
      }

      // 创建打印窗口
      const printWindow = window.open('');
      const printDoc = printWindow.document;
      
      // 写入基础样式
      printDoc.write(`
        <html>
          <head>
            <meta charset="UTF-8">
            <title>打印单据 - 共 ${this.totalPages} 页</title>
            <style>
              body {
                font-family: "SimSun", Arial, sans-serif;
                margin: 0;
                padding: 0;
              }
              .print-page {
                margin: 0 auto;
                width: ${this.form.width}px;
                height: ${this.form.height}px;
                padding: 20px;
                box-sizing: border-box;
                position: relative;
              }
              /* 第一页：不要尾 */
              .print-page:first-child {
                page-break-after: avoid;
              }
              /* 中间页：既不要头也不要尾 */
              .print-page:not(:first-child):not(:last-child) {
                page-break-before: always;
                page-break-after: avoid;
              }
              /* 最后一页：要尾（自动结束） */
              .print-page:last-child {
                page-break-before: always;
              }
              .item-braid-table table {
                border-collapse: collapse !important;
                width: 100% !important;
              }
              .item-braid-table th,
              .item-braid-table td {
                border: 1px solid #000 !important;
                padding: 8px 10px !important;
                text-align: center !important;
                word-wrap: break-word !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              .total-row {
                font-size: 14px !important;
              }
              .page-info {
                position: absolute;
                bottom: 10px;
                right: 20px;
                font-size: 12px;
                color: #666;
              }
              .template-item {
                position: absolute !important;
              }
              .text-content {
                white-space: pre-wrap !important;
              }
              /* 隐藏非表格元素的类 */
              .hide-non-table {
                display: none !important;
              }
            </style>
          </head>
          <body>
      `);

      // 遍历分页数据，生成多页内容
      this.paginatedData.forEach((pageData, pageIndex) => {
        // 复制原始模板（包含所有文本元素）
        const pageTemplate = originalTemplate.cloneNode(true);
        pageTemplate.className = 'print-page';
        
        // 如果不是第一页，隐藏所有非表格元素
        if (pageIndex > 0) {
          const nonTableElements = pageTemplate.querySelectorAll('.template-item:not(.item-braid-table)');
          nonTableElements.forEach(element => {
            element.classList.add('hide-non-table');
          });
        }
        
        // 找到表格元素
        const tableElement = pageTemplate.querySelector('.detail-table');
        if (tableElement) {
          const tableBody = tableElement.querySelector('tbody');
          if (tableBody) {
            // 清空原有数据行和合计行
            tableBody.innerHTML = '';
            
            // 添加当前页数据行
            pageData.forEach((row, rowIndex) => {
              const tr = document.createElement('tr');
              this.columns.forEach(col => {
                const td = document.createElement('td');
                td.textContent = row[col.name] || '';
                tr.appendChild(td);
              });
              tableBody.appendChild(tr);
            });
            
            // 只在最后一页添加合计行
            if (pageIndex === this.paginatedData.length - 1) {
              const totalTr = document.createElement('tr');
              totalTr.className = 'total-row';
              
              // 创建"合计"单元格
              const totalTd = document.createElement('td');
              totalTd.colSpan = this.summaryColspan;
              totalTd.style.textAlign = 'center';
              totalTd.style.fontWeight = 'bold'; // 可选：加粗合计文本
              // 直接使用计算后的合计文本，而非summaryText
              totalTd.textContent = this.hasAmountColumn 
                ? `合计金额：${this.form.amout_money}`
                : this.hasQuantityColumn 
                  ? `合计数量：${this.form.amout_num}`
                  : '合计';
              totalTr.appendChild(totalTd);
              
              // 添加数量合计单元格（直接用calculatedTotals）
              if (this.hasQuantityColumn) {
                const quantityTd = document.createElement('td');
                quantityTd.style.fontWeight = 'bold';
                quantityTd.style.textAlign = 'center';
                quantityTd.textContent = this.calculatedTotals.quantityTotal; // 直接用计算值
                totalTr.appendChild(quantityTd);
              }
              
              // 数量列和金额列之间的填充单元格（不变）
              for (let i = 0; i < this.betweenColumns; i++) {
                const emptyTd = document.createElement('td');
                totalTr.appendChild(emptyTd);
              }
              
              // 添加金额合计单元格（直接用calculatedTotals）
              if (this.hasAmountColumn) {
                const amountTd = document.createElement('td');
                amountTd.style.fontWeight = 'bold';
                amountTd.style.textAlign = 'center';
                amountTd.textContent = this.calculatedTotals.amountTotal; // 直接用计算值
                totalTr.appendChild(amountTd);
              }
              
              // 金额列之后的填充单元格（不变）
              for (let i = 0; i < this.afterAmountColumns; i++) {
                const emptyTd = document.createElement('td');
                totalTr.appendChild(emptyTd);
              }
              
              tableBody.appendChild(totalTr);
            }


          }
        }
        
        // 添加页码信息（每页都显示）
        const pageInfo = document.createElement('div');
        pageInfo.className = 'page-info';
        pageInfo.textContent = `第 ${pageIndex + 1} 页 / 共 ${this.totalPages} 页`;
        pageTemplate.appendChild(pageInfo);
        
        // 添加到打印文档
        printDoc.body.appendChild(pageTemplate);
      });

      printDoc.write(`</body></html>`);
      printDoc.close();

      // 执行打印
      printWindow.onload = function() {
        setTimeout(() => {
          printWindow.print();
          printWindow.onafterprint = function() {
            setTimeout(() => {
              printWindow.close();
            }, 100);
          };
        }, 500);
      };
    }
  }
};
</script>

<style>
/* 文本元素样式 */
.text-content {
  padding: 4px;
  white-space: pre-wrap;
}

/* 表格样式 */
.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  table-layout: fixed;
}

.detail-table th,
.detail-table td {
  border: 1px solid #333;
  padding: 4px 10px;
  text-align: center;
  word-wrap: break-word;
}

.total-row {
  /* font-weight: bold; */
  font-size: 14px;
}

/* 加载提示 */
.loading-container {
  text-align: center;
  padding: 50px;
  color: #999;
}

.el-icon-loading {
  margin-right: 10px;
}

/* 打印样式优化 */
@media print {
  .el-button {
    display: none !important;
  }
  
  .print-template {
    border: none !important;
    padding: 0 !important;
  }
  
  .detail-table th,
  .detail-table td {
    border: 1px solid #000 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  
  /* 在打印时也隐藏非表格元素 */
  .hide-non-table {
    display: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/order/order/genorder.vue